module.exports = __webpack_public_path__ + "c1e88a916be1c72f688c9e488cdd4516.svg";